var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 20.003,
    viewBox: "0 0 19.5 20.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diploma-verified-svgrepo-com",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7287",
    "data-name": "Path 7287",
    d: "M6.5,16.4c-1.958-.011-3.018-.1-3.709-.789C2,14.818,2,13.546,2,11V7.4c0-2.546,0-3.818.791-4.609S4.854,2,7.4,2h7.2c2.546,0,3.818,0,4.609.791S20,4.854,20,7.4V11c0,2.546,0,3.818-.791,4.609-.657.657-1.646.768-3.421.787l-.738,0",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7288",
    "data-name": "Path 7288",
    d: "M9,6h5.4",
    transform: "translate(-0.7 -0.4)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7289",
    "data-name": "Path 7289",
    d: "M7,9.5h9",
    transform: "translate(-0.5 -0.75)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    d: "M10.555,13.9a1.539,1.539,0,0,1,2,0,1.539,1.539,0,0,0,.876.363,1.539,1.539,0,0,1,1.412,1.412,1.539,1.539,0,0,0,.363.876,1.539,1.539,0,0,1,0,2,1.539,1.539,0,0,0-.363.876,1.539,1.539,0,0,1-1.412,1.412,1.539,1.539,0,0,0-.876.363,1.539,1.539,0,0,1-2,0,1.54,1.54,0,0,0-.876-.363,1.539,1.539,0,0,1-1.412-1.412,1.539,1.539,0,0,0-.363-.876,1.539,1.539,0,0,1,0-2,1.539,1.539,0,0,0,.363-.876,1.539,1.539,0,0,1,1.412-1.412A1.539,1.539,0,0,0,10.555,13.9Z",
    transform: "translate(-0.554 -1.154)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    d: "M10.5,18.08l.771.72L13.2,17",
    transform: "translate(-0.85 -1.5)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.be52e91240d1c2f397175e3643e99c65.svg";
export { ForwardRef as ReactComponent };